export default function store() {
    const KEY = 'compareQueue';

    let items = JSON.parse(localStorage.getItem(KEY)) || [];

    return {
        add: item => {
            items.push(item);
            localStorage.setItem(KEY, JSON.stringify(items));
            return items;
        },
        remove: item => {
            const index = items.findIndex(obj => +obj.id === +item.id);

            if (index > -1) {
                items.splice(index, 1);
                localStorage.setItem(KEY, JSON.stringify(items));
            }

            return items;
        },
        clear: () => {
            items = [];
            localStorage.removeItem(KEY);
            return items;
        },
        getAll: () => items
    };
}
